var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.3328 20H5.66618C2.2769 20 0 17.6229 0 14.0843V5.91672C0 2.37811 2.2769 0 5.66618 0H14.3338C17.7231 0 20 2.37811 20 5.91672V14.0843C20 17.6229 17.7231 20 14.3328 20Z",
    fill: "#0A74DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2451 6.67545C9.2451 8.04545 8.1301 9.16045 6.7601 9.16045C5.3891 9.16045 4.2751 8.04545 4.2751 6.67545C4.2751 5.30545 5.3891 4.18945 6.7601 4.18945C8.1301 4.18945 9.2451 5.30545 9.2451 6.67545ZM17.4005 12.0881C17.6335 12.3141 17.8005 12.5721 17.9105 12.8471C18.2435 13.6791 18.0705 14.6791 17.7145 15.5031C17.2925 16.4841 16.4845 17.2251 15.4665 17.5491C15.0145 17.6941 14.5405 17.7561 14.0675 17.7561H5.6865C4.8525 17.7561 4.1145 17.5621 3.5095 17.1981C3.1305 16.9701 3.0635 16.4451 3.3445 16.1031C3.8145 15.5331 4.2785 14.9611 4.7465 14.3841C5.6385 13.2801 6.2395 12.9601 6.9075 13.2411C7.1785 13.3571 7.4505 13.5321 7.7305 13.7161C8.4765 14.2101 9.5135 14.8881 10.8795 14.1521C11.8132 13.6415 12.3552 12.7678 12.827 12.0074L12.8365 11.9921C12.8682 11.9412 12.8997 11.8903 12.9311 11.8396C13.0915 11.5804 13.2495 11.3251 13.4285 11.0901C13.6505 10.7991 14.4745 9.88905 15.5395 10.5371C16.2185 10.9451 16.7895 11.4971 17.4005 12.0881Z",
    fill: "#0A74DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/empty-image.65e981c78fc1a9728df05613a6570909.svg";
export { ForwardRef as ReactComponent };